import loadable from '@loadable/component';
export const manifest = {
  SmeSearchInn: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnContext";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnContext" */
          './search-inn-context'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./search-inn-context");
            }

            return eval('require.resolve')("./search-inn-context");
          }

        }, {
          resolveComponent: mod => mod.SearchInnContext
        })
      }
    }
  },
  'SmeSearchInn.Control': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnControl";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnControl" */
          './search-inn-control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./search-inn-control");
            }

            return eval('require.resolve')("./search-inn-control");
          }

        }, {
          resolveComponent: mod => mod.SearchInnControl
        })
      }
    }
  },
  'SmeSearchInn.ResultViewer': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnResultViewerDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnResultViewerDesktop" */
          './result-viewer-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./result-viewer-desktop");
            }

            return eval('require.resolve')("./result-viewer-desktop");
          }

        }, {
          resolveComponent: mod => mod.SearchInnResultViewerDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnResultViewerMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnResultViewerMobile" */
          './result-viewer-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./result-viewer-mobile");
            }

            return eval('require.resolve')("./result-viewer-mobile");
          }

        }, {
          resolveComponent: mod => mod.SearchInnResultViewerMobile
        })
      }
    }
  },
  'SmeSearchInn.ResultCountViewer': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnResultCountViewer";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnResultCountViewer" */
          './result-count-viewer'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./result-count-viewer");
            }

            return eval('require.resolve')("./result-count-viewer");
          }

        }, {
          resolveComponent: mod => mod.SearchInnResultCountViewer
        })
      }
    }
  },
  'SmeSearchInn.Trigger': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnTrigger";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnTrigger" */
          './trigger'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./trigger");
            }

            return eval('require.resolve')("./trigger");
          }

        }, {
          resolveComponent: mod => mod.SearchInnTrigger
        })
      }
    }
  },
  'SmeSearchInn.TriggerViewer': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnTriggerViewer";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnTriggerViewer" */
          './trigger-viewer'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./trigger-viewer");
            }

            return eval('require.resolve')("./trigger-viewer");
          }

        }, {
          resolveComponent: mod => mod.SearchInnTriggerViewer
        })
      }
    }
  },
  'SmeSearchInn.Tabs': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnTabsDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnTabsDesktop" */
          './tabs-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./tabs-desktop");
            }

            return eval('require.resolve')("./tabs-desktop");
          }

        }, {
          resolveComponent: mod => mod.SearchInnTabsDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SearchInnSearchInnTabsMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SearchInnSearchInnTabsMobile" */
          './tabs-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./tabs-mobile");
            }

            return eval('require.resolve')("./tabs-mobile");
          }

        }, {
          resolveComponent: mod => mod.SearchInnTabsMobile
        })
      }
    }
  }
};